import React from "react";
import { Box, Button, Dialog, Stack, Text } from "@origin-digital/ods-core";
import { AccountAlreadyClosedDialogProps } from "./types";
import { useAccountAlreadyClosedDialogContext } from "./context";

export const AccountAlreadyClosedDialog: React.FC<
  AccountAlreadyClosedDialogProps
> = (props) => {
  const { closeDialog, id } = useAccountAlreadyClosedDialogContext();
  return (
    <Dialog
      id={id}
      open={true}
      title="Account already closed"
      onClose={() => closeDialog()}
    >
      <Stack space="small">
        {/* Content */}
        <Stack space="medium">
          <Text>
            The account is no longer in {props.requestingCompany} name. The
            status will be changed to 'All done'.
          </Text>
        </Stack>

        {/* End Content */}

        {/* Actions */}
        <Box
          position={{
            lg: "static",
            xs: "fixed",
          }}
          paddingTop={{
            lg: "medium",
            xs: "medium",
          }}
          paddingBottom={{
            lg: "none",
            xs: "large",
          }}
          paddingX={{
            lg: "none",
            xs: "medium",
          }}
          backgroundColor="white"
          width="full"
          style={{
            left: "0",
            bottom: "0",
            zIndex: "1",
          }}
        >
          <Box
            display="flex"
            flexWrap={{
              lg: "nowrap",
              xs: "wrap",
            }}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Button onClick={() => closeDialog()}>Got it!</Button>
          </Box>
        </Box>
        {/* End Actions */}
      </Stack>
    </Dialog>
  );
};
